export const environment = {
  production: false,
  title: 'iAM',
  ssoApi: 'https://sso.rec.galec.fr/auth/realms/baseinfosmag-rec/protocol/openid-connect/token',
  sso: {
    url: 'https://sso.rec.galec.fr/auth',
    realm: 'baseinfosmag-rec',
    clientId: 'baseinfosmag-iam-client'
  },
  graphQL: 'https://graphql.rec.bimleclerc.fr/v1/graphql',
  graphQL_WS: 'wss://graphql.rec.bimleclerc.fr/v1/graphql',
  dam_key: "fee6bde1-3c5a-47cb-9996-e0f1307b806c",
  maintenance: false,
  back_end_bim: "https://rest.rec.bimleclerc.fr",
  google_analytics_code: "G-93PQQ3RDZ8"
};
